import React, { useEffect, useState } from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  Linking,
} from "react-native";
import { Modal } from "@components/TrackedModal";
import { useSelector } from "react-redux";
import { APP_VERSION } from "@config";
import t from "@constants/localization";
import color from "../constants/color";
import { STATE_STATUS } from "../reducers/actionTypes";

const PATH = "components/UpdateAppModal";

const UpdateAppModal = () => {
  const [isAppUpdated, setIsAppUpdated] = useState(true);
  const config = useSelector((state) => state.configReducer);

  useEffect(() => {
    if (config.status === STATE_STATUS.FETCHED) {
      const { versionId } = config.version || {};
      if (APP_VERSION < versionId) {
        setIsAppUpdated(false);
      } else {
        setIsAppUpdated(true);
      }
    }
  }, [config.status, config.version]);

  const handleButtonPress = () => {
    Linking.openURL(
      "https://play.google.com/store/apps/details?id=live.citymall.partnerdb&hl=en_US",
    );
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="fade"
      visible={!isAppUpdated}
      transparent
      eventType="Force Update App Modal"
    >
      <View
        style={{
          backgroundColor: "rgba(0, 0, 0, .8)",
          padding: 32,
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View style={styles.dialog}>
          <Text style={{ textAlign: "center", fontSize: 18 }}>
            {t(`${PATH}/updateAppMsg`)}
          </Text>
          <Text
            style={{
              textAlign: "center",
              paddingTop: 20,
              paddingBottom: 20,
              fontSize: 18,
            }}
          >
            {t(`${PATH}/pressBelowToUpdate`)}
          </Text>
          <TouchableOpacity
            testID="uam-update-button"
            onPress={handleButtonPress}
            style={{
              padding: 16,
              borderRadius: 15,
              overflow: "hidden",
              margin: 10,
              backgroundColor: color.primary,
            }}
          >
            <Text style={{ textAlign: "center", color: "#fff" }}>Update</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  dialog: {
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 5,
    elevation: 6,
    width: "85%",
  },
});

export default UpdateAppModal;
